import {React} from '@api';
import {observer} from 'mobx-react';
import {styled} from '@pdf'

const CustomAttributePdfView = styled.View`
  display:flex;
  flex-direction: row;
  overflow: hidden;
`

const SpecItemView = styled.View`
  overflow: hidden;
  display: flex;
  flex-direction: row;
`

const SpecLabelText = styled.Text`
  font-family: Helvetica;
  white-space: nowrap;
  text-align: left;
  line-height:1px;
  font-size: 6px;
  width:100%;
`

@observer
export class VlpCustomAttributePdf extends React.Component<{ style?: any, textStyle?: any, attributeLabel: string, attributeValue?: string }> {
  render() {
    let {props: {style, textStyle, attributeLabel, attributeValue}} = this

    return (
      <CustomAttributePdfView>
        <SpecItemView>
          <SpecLabelText style={{maxLines:1,textOverflow:'ellipsis'}}>{attributeValue || '--'}</SpecLabelText>
        </SpecItemView> 
      </CustomAttributePdfView>)
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/VlpCustomAttributePdf.tsx